import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio", "viewBox"];
import React from 'react';

var ArcLoader = function ArcLoader(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  var groupElement = React.useRef(null);

  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      transformOrigin = _React$useState2[0],
      setTransformOrigin = _React$useState2[1];

  React.useEffect(function () {
    if (groupElement.current != null && groupElement.current.getBBox != null) {
      var rect = groupElement.current.getBBox();
      var cx = rect.x + rect.width / 2;
      var cy = rect.y + rect.height / 2;
      setTransformOrigin("".concat(cx, " ").concat(cy));
    }
  }, [groupElement]);
  return /*#__PURE__*/React.createElement("svg", _extends({}, unhandledProps, {
    preserveAspectRatio: preserveAspectRatio,
    viewBox: viewBox
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    ref: groupElement
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22.25 12c0 0.6-0.45 1.25-1.25 1.25s-1.25-0.65-1.25-1.25c0-4.2802-3.4698-7.75-7.75-7.75-4.2802 0-7.75 3.4698-7.75 7.75 0 4.2802 3.4698 7.75 7.75 7.75 0.7875 0 1.25 0.65 1.25 1.25 0 0.57483-0.33864 1.0439-0.94922 1.2109-0.075161 0.020558-0.17542 0.033579-0.30078 0.039062-5.6609 0-10.25-4.5891-10.25-10.25 0-5.6609 4.5891-10.25 10.25-10.25 5.6609 0 10.25 4.5891 10.25 10.25z"
  }), transformOrigin != null && /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: "0s",
    dur: "1s",
    type: "rotate",
    from: "0 ".concat(transformOrigin),
    to: "360 ".concat(transformOrigin),
    repeatCount: "indefinite"
  })));
};

ArcLoader.displayName = 'ArcLoader';
export default ArcLoader;